

exports.__esModule = true;
exports.$xoSidebarUpdateCardComponent = undefined;

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarUpdateCardComponent = exports.$xoSidebarUpdateCardComponent = _squid.$Component.extend('$xoSidebarUpdateCardComponent', {
    tag: 'xo-sidebar-update-card',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        backUri: {
            type: 'var',
            required: false
        },
        doneUri: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.fundingid = _uiRouter.$stateParams.planId;
            this.updateCardCPA = _uiRouter.$stateParams.updateCardCPA;
            this.sidebar = true;
            this.backUri = this.props.backUri;
            var doneUri = _uiRouter.$stateParams.doneUri;

            this.callbacks = {
                finish: function finish() {
                    _uiRouter.$state.go(doneUri || 'checkout.review.sidebar.sidebarManageWallet');
                }
            };
        }
    }
});

angular.value("$xoSidebarUpdateCardComponent", $xoSidebarUpdateCardComponent);
_squid.$Component;

_uiRouter.$state;

_uiRouter.$stateParams;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-update-card/directive.js
// module id = ./pages/xo-sidebar-update-card/directive.js
// module chunks = 0